export default __webpack_public_path__ + "static/media/ioasys.d4283786.jpg";